import React from 'react';
import { Button } from './ui/button';
import { MoveRight, PhoneCall } from 'lucide-react';

interface HeroProps {
  businessName: string;
}

const Hero: React.FC<HeroProps> = ({ businessName }) => {
  return (
    <div className="relative min-h-screen bg-gradient-to-b from-black/60 to-black/30">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/images/home/hero.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
          }}
        />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/80 via-black/60 to-black/30 pointer-events-none" />
      
      <div className="relative z-20 container mx-auto px-4 h-screen flex flex-col lg:flex-row items-center justify-center text-center lg:text-left text-white">
        <div className="w-full lg:w-1/2 flex flex-col justify-center items-center lg:items-start">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            {businessName}
          </h1>
          <p className="text-xl md:text-2xl mb-4">
            Transforming visions into reality
          </p>
          <p className="text-lg md:text-xl mb-8">
            Over 20 years of excellence in construction
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="bg-white text-black hover:bg-white/90 gap-2"
              onClick={() => {
                const contactSection = document.getElementById('contact');
                contactSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Contact Us <PhoneCall className="w-4 h-4" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-white hover:bg-white/10 gap-2"
              onClick={() => {
                const servicesSection = document.getElementById('services');
                servicesSection?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Our Services <MoveRight className="w-4 h-4" />
            </Button>
          </div>
        </div>
        <div className="hidden lg:block w-1/2"></div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div 
          className="animate-bounce cursor-pointer"
          onClick={() => {
            const aboutSection = document.getElementById('about');
            aboutSection?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <svg 
            className="w-6 h-6 text-white"
            fill="none" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Hero; 